export const APP_VERSION = '1.3.3';
// para tts
export const APP_NAME = 'Time Tax Support';
export const LOGO_PATH = '/images/logo-tts.png';
export const LOGO_PATROCINADOR = '';
export const DISABLE_MMI_OPTION = true;
export const SHOW_MMI_OPTION = false;
export const SHOW_HORAS_ESTIMADAS = false;

// para tpx
// export const APP_NAME = 'Transfer Pricing Extreme';
// export const LOGO_PATH = '/images/logo-tpx.png';
// export const LOGO_PATROCINADOR = 'images/basefirma-big.png';
// export const DISABLE_MMI_OPTION = false;
// export const SHOW_MMI_OPTION = true;
// export const SHOW_HORAS_ESTIMADAS = true;

export const routes = {
  activity: '/actividad',
  activity_import: '/actividad-import',
  activity_checker: '/actividad-checker',
  distribution_corrector: '/distribution-corrector',
  project: '/proyectos-list-detalles',
  project_list: '/proyectos-list',
  project_config: '/proyectos-list-config',
  project_panel: 'proyectos-list-proyectos-panel',
  project_docs: 'proyectos-docs-obligatorios',
  edit_distribution_by_period: '/proyectos-list-edit-distribution-by-period',
  view_distribution_by_period: '/proyectos-list-view-distribution-by-period',
  activity_list: '/activity-list',
  collaborator_list: '/colaboradores-list',
  collaborator: '/mi-panel-colaboradores-colaboradores',
  calendar: '/calendario',
  documents: '/documentos',
  dashboard: '/mi-panel-proyectos',
  dashboard_own: '/mi-panel',
  dashboard_empresas: '/mi-panel-empresas',
  dashboard_colaboradores: '/mi-panel-colaboradores',
  reports: '/reportes',
  reportsCompany: '/reportes-empresas',
  reportsSector: '/reportes-sector',
  reportsProject: 'reportes-proyecto',
  reportsProjectDocs: 'reportes-docs-obligatorios-proyecto',
  reportsMMI: '/reportes-mmi',
  reportsBillableDistribution: '/distribucion-facturable',
  preliquidation: '/preliquidacion',
  liquidation: '/liquidacion-directa',
  settlement: '/liquidaciones',
  direct_settlement: '/liquidaciones-directas-list-detalle',
  settlement_list: '/liquidaciones-list',
  direct_settlement_list: '/liquidaciones-directas-list',
  settlementView: '/asistente-liquidaciones',
  directSettlementView: '/liquidaciones-directas-list-asistente',
  collaborators: '/colaboradores',
  notifications: '/notificaciones',
  // defenseFile: '/archivo-defensa',
  admin: '/admin',
  basic_inputs: '/basic-inputs',
  form_example: '/form-example',
  login: '/login',
  recover_password: '/recover-password',
  wizard: '/wizard',
  defense_file_assistant: '/archivos-defensa-asistente',
  defense_file: '/archivos-defensa',
  massive_defense_list: '/defensa-masiva-list',
  massive_defense_view: '/defensa-masiva-list-asistente',
  massive_defense: '/defensa-masiva-list',
  control_doc: '/doc_obligatorio',
  company_tree: '/company-tree',
  cost_center: '/cost-center',
  maintenance: '/maintenance',
  help: '/help',
  licenses: '/licenses',
  licences_config: '/licenses-generate',
  mails: '/mails',
  massive_mail_inspector: '/proyectos-mmi',
  bloqueo_periodos: '/bloqueo-periodos',
  cost_per_hour_list: '/costo-por-hora',
  cost_per_hour_view: '/costo-por-hora-asistente-plantillas',
  cost_per_hour_detail: '/costo-por-hora-detalle',
  cargar_por_fomulario: '/cargar-por-fomulario',
  working_days_holidays: '/dias-laborales-feriados',
  empresas: '/empresas',
  carga_por_tabla:'/carga-por-tabla',
  notification_by_hierarchies: '/notification-by-hierarchies',
  politica_de_privacidad: '/politica-de-privacidad',
  terminos_y_condiciones: '/terminos-y-condiciones'
};

export const includesThisRoute = (routesAvailables: string[], pathname: string) => {
  routesAvailables.forEach((route) => {
    if (route[0] === '/') {
      let str = route.slice();
      if (pathname === str) {
        return true;
      }
    }
  });

  return false;
};

export const routesAvailableForStandardUser = [
  routes.activity,
  routes.activity_list,
  routes.distribution_corrector,
  routes.activity_import,
  routes.activity_checker,
  routes.project,
  routes.project_list,
  routes.project_config,
  routes.project_panel,
  routes.project_docs,
  routes.calendar,
  routes.dashboard_own,
  routes.notifications,
  routes.collaborator,
  routes.login,
  routes.recover_password,
  routes.politica_de_privacidad,
  routes.terminos_y_condiciones,
  routes.maintenance,
  routes.help,
  routes.licenses,
  routes.licences_config,
  routes.carga_por_tabla,
  routes.cargar_por_fomulario,
];

export const routesAvailableForDirective = [
  ...routesAvailableForStandardUser,
  routes.collaborator_list,
  routes.documents,
  routes.dashboard,
  routes.dashboard_empresas,
  routes.dashboard_colaboradores,
  routes.reports,
  routes.reportsCompany,
  routes.reportsProject,
  routes.reportsProjectDocs,
  routes.collaborators,
  routes.wizard,
  routes.preliquidation,
  routes.reportsSector,
  routes.company_tree,
  routes.cost_center,
  routes.massive_mail_inspector,
  routes.reportsMMI,
  routes.cost_per_hour_list,
  routes.cost_per_hour_view,
  routes.cost_per_hour_detail,
];

export const routesAvailableForPowerUser = [
  ...routesAvailableForDirective,
  routes.working_days_holidays,
  routes.empresas,
  routes.notification_by_hierarchies,
  routes.settlement,
  routes.direct_settlement,
  routes.settlement_list,
  routes.direct_settlement_list,
  routes.settlementView,
  routes.admin,
  routes.defense_file_assistant,
  routes.defense_file,
  routes.control_doc,
  routes.directSettlementView,
  routes.liquidation,
  routes.massive_defense,
  routes.massive_defense_list,
  routes.massive_defense_view,
  routes.mails,
  routes.bloqueo_periodos,
  routes.edit_distribution_by_period,
  routes.view_distribution_by_period,
  routes.reportsBillableDistribution,
];

export const newEntityDefaultId = 'new';

export const defenseFileAssistantDropdownValues = {
  forProjects: '2',
  forIndirectsSettlements: '1',
};

export const maxBytesPerUpload = 1024 ** 3; // 1 GB
// export const maxBytesPerUpload = 16 * 1024; // 10 KB
export const fileUploadProgressTimeout = 10000;
